/**
 * token
 */
import Storage from 'store2'               //  本地存储

const storageTokenKey = 'tokenData';					//	本地缓存key
let storageTokenData = Storage.get(storageTokenKey); 	//	从缓存中获得数据

//	数据内容
let state = {
	tokenData: storageTokenData ? storageTokenData : {}, //	Token信息
}

//	同步
const mutations = {
	setTokenDataSync(state, tokenData) {
		//	赋值Token信息
		Storage.set(storageTokenKey, tokenData); //	将数据保存到缓存中
		state.tokenData = tokenData;
	},

}

//	异步，外部保存数据调用此内部方法
const actions = {
	setTokenData({
		commit
	}, tokenData) {
		//	赋值Token信息
		commit("setTokenDataSync", tokenData);
	},
}

//	获取
const getters = {
	getTokenData(state) {
		//	获取Token信息
		return state.tokenData;
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
